module.exports = __webpack_public_path__ + "img/icon-web-site.b68c5d93.svg";